import { ceilMeasure, headerHeight, marginTopForMeetingPlaner, setClass, useViewModel } from '@utils';
import React, { FC, useMemo } from 'react';
import '../../styles/components/occupiedTime.scss';
import { observer } from 'mobx-react-lite';
import { CalendarViewModel } from '@views';

interface OccupiedTimeProps {
  start: Date;
  end: Date;
}

export const OccupiedTime: FC<OccupiedTimeProps> = observer(({ start, end }) => {
  const calendarViewModel = useViewModel(CalendarViewModel);

  // 6, 12 - чтобы перед и после встречи были также недоступны 5 минут. В пикселях 5мин = 6пкс
  const height = useMemo(() =>
    ((((end.getHours() - start.getHours()) * 60)
      - start.getMinutes() + end.getMinutes()) / ceilMeasure) + 6
    , [start, end]);

  const top = useMemo(() =>
    ((((start.getMinutes() + start.getHours() * 60) + headerHeight) - (calendarViewModel.startHour * 60)) / ceilMeasure) - 12,
    [start.getMinutes(), calendarViewModel.startHour]);

  return (
    <div
      className='occupied-time'
      style={{ top: top + marginTopForMeetingPlaner, height }}
    />
  );
});
